import {
  FETCH_WORKLIST_ERROR,
  FETCH_WORKLIST_START,
  FETCH_WORKLIST_SUCCESS,
  SET_WORKLIST_PAGINATION,
  UNDO_WORKLIST_VISIT_SUCCESS,
  UPDATE_WORKLIST_EXAMINATION_STATE_ERROR,
  UPDATE_WORKLIST_EXAMINATION_STATE_SUCCESS,
  SET_WORKLIST_CONTEXT,
  CLEAR_WORKLIST_CONTEXT
} from "../../actions/receptionist/worklistAction";
import { getWorklistContext, setWorklistContext, clearWorklistContext } from "../../actions/worklistSession";
import _ from "lodash";

// Restore persisted context from sessionStorage if available
const persistedContext = getWorklistContext();

const INIT_STATE = {
  error: "",
  loading: false,
  message: "",
  worklist: [],
  pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 0,
      totalItems: 0,
  },
  fromWorklist: false,
  originatingExaminationId: null,
  originatingTechnician: null,
  originatingMachineId: null,
  worklistVisitId: null,
  ...persistedContext, // <-- overwrite defaults if context exists
};

const worklistReducer = (state = INIT_STATE, action) => {
  let newState;
  let index;

  switch (action.type) {
    case FETCH_WORKLIST_START: {
      return { ...state, error: "", message: "", loading: true };
    }

    case FETCH_WORKLIST_SUCCESS: {
      return {
        ...state,
        error: "",
        message: "",
        loading: false,
        worklist: action.worklist.length > 0 ? [...action.worklist] : [],
      };
    }

    case FETCH_WORKLIST_ERROR: {
      return { ...state, error: "", message: "", loading: false, worklist: [] };
    }

    case SET_WORKLIST_PAGINATION: {
        return { ...state, error: '', message: '', pagination: { ...action.pagination } };
    }

    case UPDATE_WORKLIST_EXAMINATION_STATE_SUCCESS: {
      newState = _.cloneDeep(state);

      if (action.worklistItem.endTime === null) {
        index = newState.worklist.findIndex(
          (item) => item.examinationId === action.worklistItem.examinationId
        );

        if (index > -1) {
          newState.worklist[index] = { ...newState.worklist[index], ...action.worklistItem };
          return newState;
        }
      } else {
        let modifiedWorklist = newState.worklist.filter(
          (item) => item.examinationId !== action.worklistItem.examinationId
        );
        newState.worklist = _.cloneDeep(modifiedWorklist);
        return newState;
      }
      return state;
    }

    case UPDATE_WORKLIST_EXAMINATION_STATE_ERROR: {
      return { ...state, error: "", message: "", loading: false };
    }

    case UNDO_WORKLIST_VISIT_SUCCESS: {
      newState = _.cloneDeep(state);

      for (let i = 0; i < newState.worklist.length; i++) {
        if (newState.worklist[i].accessionNo === action.visitNo) {
          let selectedWorklistItem = newState.worklist[i];
          selectedWorklistItem.startTime = null;
          selectedWorklistItem.technician = null;
          newState.worklist[i] = selectedWorklistItem;
        }
      }
      return { ...newState };
    }

    case SET_WORKLIST_CONTEXT: {
      // persist context into sessionStorage
      setWorklistContext(action.payload);
      return { ...state, ...action.payload };
    }

    case CLEAR_WORKLIST_CONTEXT: {
      // clear from sessionStorage
      clearWorklistContext();
      return {
        ...state,
        fromWorklist: false,
        originatingExaminationId: null,
        originatingTechnician: null,
        originatingMachineId: null,
        worklistVisitId: null,
      };
    }

    default:
      return state;
  }
};

export default worklistReducer;
